import React from 'react';
import logoImg from '../../assets/logo.png';
import './Logo.css';

function Logo({children}) {
  return (
    <img src={children === 'Success' ? logoImg : logoImg} className="logoImg" alt="logo" />
  )
}

export default Logo;